export const userTypes = [
    { id: 1, label: "Administrateur" },
    { id: 2, label: "Membre" },
    { id: 3, label: "Contributeur" },
];
